import { Box, Typography } from '@mui/material';

import Input from '../../../form/Input';
import Select from '../../../form/Select';
import Checkbox from '../../../form/Checkbox';

export default function PessoaTabDocumentos({ module, optionsCnhCategoria }) {
    const { dados } = module.state;
    const { change } = module.actions;

    return (
        <Box sx={{ display: 'grid', gap: 1 }}>
            <Typography variant="h6">CNH</Typography>

            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <Input text="CNH" name="pessoaFisica.cnh" inputWidth="200px" handleOnChange={change} value={dados.cnh || ''} />

                <Select
                    title="Selecione a categoria da cnh exigida para conduzir o veículo"
                    text="Categoria"
                    name="pessoaFisica.cnhCategoriaId"
                    options={optionsCnhCategoria}
                    handleOnChange={change}
                    value={dados.cnhCategoriaId || ''}
                    notOptNull={false}
                />

                <Input
                    text="Primeira CNH"
                    type="date"
                    name="pessoaFisica.cnhPrimeira"
                    handleOnChange={change}
                    value={dados.cnhPrimeira || ''}
                />

                <Input
                    text="Validade CNH"
                    type="date"
                    name="pessoaFisica.cnhValidade"
                    handleOnChange={change}
                    value={dados.cnhValidade || ''}
                />
                <Input
                    text="Validade Exame"
                    title="Validade do exame toxicológico"
                    type="date"
                    name="pessoaFisica.cnhExameToxicologicoValidade"
                    handleOnChange={change}
                    value={dados.cnhExameToxicologicoValidade || ''}
                />
            </Box>

            <Typography variant="h6">Documentos</Typography>

            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <Input text="PIS" name="pessoaFisica.pis" inputWidth="200px" handleOnChange={change} value={dados.pis || ''} />

                <Input
                    text="Título"
                    name="pessoaFisica.titulo"
                    inputWidth="200px"
                    handleOnChange={change}
                    value={dados.titulo || ''}
                />

                <Input
                    text="Zona"
                    name="pessoaFisica.zona"
                    inputWidth="80px"
                    title="número da zona eleitoral"
                    handleOnChange={change}
                    value={dados.zona || ''}
                />

                <Input
                    text="Seção"
                    name="pessoaFisica.secao"
                    title="número da secção eleitoral"
                    inputWidth="80px"
                    handleOnChange={change}
                    value={dados.secao || ''}
                />

                <Input text="CTPS" name="pessoaFisica.ctps" inputWidth="200px" handleOnChange={change} value={dados.ctps || ''} />
            </Box>

            <Typography variant="h6">Registros Profissionais</Typography>

            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <Checkbox
                    title="Informa que a pessoa é um médico e aplica as condições no modulo de RH"
                    text="Médico"
                    name="pessoaFisica.medico"
                    handleOnChange={change}
                    value={dados.medico}
                    checked={!!dados.medico}
                />
                <Input text="CRM" name="pessoaFisica.crm" inputWidth="200px" handleOnChange={change} value={dados.crm || ''} />

                <Input
                    text="CRECI"
                    name="pessoaFisica.creci"
                    inputWidth="200px"
                    handleOnChange={change}
                    value={dados.creci || ''}
                />
            </Box>
        </Box>
    );
}
